import CryptoJS from 'crypto-js';
import config from '../config';

const generateApiHeaders = () => {
    const apiKey = process.env.REACT_APP_API_KEY;
    const apiSecret = process.env.REACT_APP_API_SECRET;
    
    if (!apiKey || !apiSecret) {
        console.error('API key or secret not found in environment variables:', {
            apiKey: !!apiKey,
            apiSecret: !!apiSecret
        });
        throw new Error('API configuration missing');
    }

    const timestamp = Date.now().toString();
    const nonce = Math.random().toString(36).substring(7);

    // Create signature
    const payload = `${apiKey}${timestamp}${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, apiSecret).toString();

    return {
        'X-API-Key': apiKey,
        'X-Timestamp': timestamp,
        'X-Nonce': nonce,
        'X-Signature': signature
    };
};

export const fetchWithAuth = async (url, options = {}) => {
    const apiHeaders = generateApiHeaders();
    const headers = {
        ...options.headers,
        ...apiHeaders,
        'Content-Type': 'application/json'
    };

    if (localStorage.getItem('token')) {
        headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    }

    const response = await fetch(url, {
        ...options,
        headers
    });

    const data = await response.json();

    if (!response.ok) {
        console.error('API request failed:', {
            status: response.status,
            data
        });
        throw new Error(data.message || 'API request failed');
    }

    return data;
};

export const getAdminUploadHeaders = () => {
    const headers = {};
    const apiKey = process.env.REACT_APP_API_KEY || config.apiKey;
    if (apiKey) {
        headers['x-api-key'] = apiKey;
    }
    const token = localStorage.getItem('token');
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};
